import { render, staticRenderFns } from "./InfiniteAfterDisposalItemSubcategoryAutoComplete.vue?vue&type=template&id=c8281834&scoped=true&"
import script from "./InfiniteAfterDisposalItemSubcategoryAutoComplete.vue?vue&type=script&lang=js&"
export * from "./InfiniteAfterDisposalItemSubcategoryAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8281834",
  null
  
)

export default component.exports